import dynamic from "next/dynamic"

// The heavy caption/places/tool-calls payload, deferred so it downloads in
// parallel with RTC startup instead of shipping in the main bundle. Isolated in
// its own module (rather than an inline dynamic() in the overlay) so tests can
// mock this boundary to an eager component without having to mock next/dynamic
// globally — a global next/dynamic mock deadlocks when its factory imports a
// chunk whose own graph re-enters next/dynamic.
export const LazyVoiceChatContent = dynamic(
  () =>
    import("./voice-chat-content").then((mod) => ({
      default: mod.VoiceChatContent,
    })),
  { ssr: false }
)
